import styled from 'styled-components'

export const ChromeLogoStyled = styled('img')`
  object-fit: cover;
  object-position: center;
  vertical-align: middle;
  width: 20px;
  height: 20px;
`
